/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import dynamic from 'next/dynamic'
const PackageSwiper = dynamic(() => import('@/components/atoms/swiper/packageSwiper'), {
  ssr: false,
  loading: () => <div className="tw-loading-placeholder">Loading...</div>
})
const CardWhatTheySay = dynamic(() => import('@/components/atoms/card/cardWhatTheySay'), {
  ssr: false,
  loading: () => <div className="tw-loading-placeholder">Loading...</div>
})
const CardTematicStudioBox = dynamic(() => import('@/components/atoms/card/cardTematicStudioBox'), {
  ssr: false,
  loading: () => <div className="tw-loading-placeholder">Loading...</div>
})

import { CardLiveShopWhatis, CardPackage, CardPointToPoint, CardRecognitions, CardWithDescription, CenteredRadiantGradient, MetaData, StyledButton } from '@/components/atoms'
import route_list from '@/constant/routeUrl'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import { background_list, icon_list } from '@/assets/images'
import { useRef, useEffect, useState } from 'react'
import { TematicStudioBox, TitleImageDescSection } from '@/components/molecules'
import app_config from '@/constant/config'
import { getSeoMetadata } from '@/utility/apiProcess/seo/server'

const LiveShoppingExperience = (props) => {
  console.log(props)
	const { t } = useTranslation('liveshop')
	const router = useRouter()
  const what_is_data = [
    {
      title: t('liveshop.why_we'),
      description: t('liveshop.why_we_desc'),
      image: background_list.liveshop1
    },
    {
      title: t('liveshop.we_offer'),
      description: t('liveshop.we_offer_desc'),
      image1: background_list.liveshop2,
      image2: background_list.liveshop3,
    },
  ]

  const swiperData2 = [
    {
      title: "Social Media Management",
      onClick: () => router.push(route_list.social_media_management),
      buttonLabel: t('liveshop.learn_more'),
    },
    {
      title: "Influencer Endorsement",
      onClick: () => router.push(route_list.endorsement),
      buttonLabel: t('liveshop.learn_more'),
    },
    {
      title: "Enterprise Solution",
      onClick: () => window.open(app_config.enterpriseUrl),
      buttonLabel: t('liveshop.learn_more'),
    },
  ]

  const swiperTestimony = [
    {
      description: `"${t('liveshop.testimoni1')}"`,
      photo: background_list.raga,
      name: "Raga Hariawan",
      position: "Senior Content Specialist @ Bukalapak"
    },
    {
      description: `"${t('liveshop.testimoni2')}"`,
      photo: background_list.vicky,
      name: "Vicky Kurniawan",
      position: "Founder @ Kibocheese"
    },
  ]

  const stepData = [
    {
      title: t('liveshop.step_1'),
      description: t('liveshop.step_1_desc')
    },
    {
      title: t('liveshop.step_2'),
      description: t('liveshop.step_2_desc')
    },
    {
      title: t('liveshop.step_3'),
      description: t('liveshop.step_3_desc')
    },
    {
      title: t('liveshop.step_4'),
      description: t('liveshop.step_4_desc')
    }
  ]

  const howAreWeData = {
    title: t('liveshop.how_dif'),
    description: t('liveshop.how_dif_desc'),
    image: background_list.liveshop4,
    points: [
      {
        title: t('liveshop.how_dif_1'),
        description: t('liveshop.how_dif_1_desc')
      },
      {
        title: t('liveshop.how_dif_2'),
        description: t('liveshop.how_dif_2_desc')
      },
      {
        title: t('liveshop.how_dif_3'),
        description: t('liveshop.how_dif_3_desc')
      },
      {
        title: t('liveshop.how_dif_4'),
        description: t('liveshop.how_dif_4_desc')
      },
    ]
  }

  const thematicData = {
    title: t('liveshop.thematic_title'),
    description: t('liveshop.thematic_desc'),
    list: [
      {
        title: t('liveshop.standard'),
        images: [background_list.studio1, background_list.studio2]
      },
      {
        title: t('liveshop.premium'),
        images: [background_list.studio3, background_list.studio4, background_list.studio5, background_list.studio6, background_list.studio7, background_list.studio8]
      }
    ]
  }

  const [isMobile, setIsMobile] = useState(false)
  
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    checkIsMobile()
    window.addEventListener('resize', checkIsMobile)
    return () => window.removeEventListener('resize', checkIsMobile)
  }, [])

      
	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 tw-py-8 md:tw-px-0 tw-px-4 tw-max-w-6xl tw-mx-auto tw-grid md:tw-grid-cols-2 tw-gap-2'>
					<div>
            <h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 md:tw-text-left tw-text-center'>
              {t('liveshop.title')}
            </h2>
            <span className='tw-text-white tw-text-sm md:tw-text-justify tw-flex tw-text-center'>
              {t('liveshop.desc')}
            </span>
            <div className='md:tw-flex tw-hidden tw-items-end tw-flex-row tw-gap-2 tw-mt-5'>
              <StyledButton onClick={() => window.open(app_config.AndroidClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.playstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
              <StyledButton onClick={() => window.open(app_config.AppstoreClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.appstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
            </div>
          </div>
          <div className='tw:w-full tw-flex tw-flex-col tw-items-center tw-justify-center'>
            <Image src={background_list.live_shopping_head } alt='' className='md:tw-w-[50%] tw-w-[50%]' />
            <div className='md:tw-hidden tw-flex tw-items-end tw-flex-row tw-gap-2 tw-mt-5'>
              <StyledButton onClick={() => window.open(app_config.AndroidClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.playstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
              <StyledButton onClick={() => window.open(app_config.AppstoreClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.appstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
            </div>
          </div>
				</div>
			</div> 
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px] tw-overflow-hidden'>
				<div className='tw-newsroom-container'>
					<div className='tw-max-w-6xl tw-mx-auto tw-my-8 md:tw-px-0 tw-px-4 tw-text-justify'>
            {/* What is */}
            <CardLiveShopWhatis data={what_is_data} />
            {/* How It Works */}
            <div className='tw-my-10'>
              <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-left tw-w-fit tw-pb-1'>{t('liveshop.how_it')}</h1>
              <p className='tw-text-left tw-mb-5'>
              {t('liveshop.how_it_desc')}
              </p>
              <div className="tw-flex tw-items-center tw-font-poppins tw-rounded-lg ">
                <div className="tw-justify-center tw-flex-1 tw-max-w-6xl">
                  <CardPointToPoint data={stepData} />
                </div>
              </div>
            </div>
            {/* How are we different? */}
            <TitleImageDescSection data={howAreWeData} isReverse={true}/>
            {/* Our Thematic Studio Box */}
            <TematicStudioBox data={thematicData} />
            {/* Our Package */}
            <div className='tw-w-full tw-rounded-2xl tw-relative tw-overflow-hidden tw-grid md:tw-grid-cols-3  md:tw-py-14 tw-py-5 md:tw-px-20 tw-px-5'>
              <Image src={background_list.card_wave_green_big} alt="arrow rotate" className='tw-absolute tw-top-0 tw-right-0 tw-z-0 tw-h-full' />
              <div className='tw-z-10 md:tw-col-span-2 '>
                  <h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 md:tw-text-left tw-text-center'>
                    {/* {t('liveshop.our_package')} */}
                    Liveshopping Lite <br />Shopee only
                  </h2>
                  <div className="tw-py-5">
                    <span className='tw-mt-5 tw-text-white'>{t('homepage.start_from')}</span>
                    <div className='tw-text-white tw-flex tw-flex-row md:tw-items-center tw-text-start'>
                      <h1 className='md:tw-text-3xl tw-text-md tw-font-semibold'>Rp 18.000.000,- <small className='tw-text-base tw-ml-2'>(+5% sharing Revenue)</small></h1>
                      {/* <span className='tw-ml-1'>({t('homepage.after_tax')})</span> */}
                    </div>
                  </div>
                  <span className='tw-text-white tw-mb-5 tw-block'>Make it more impactful With Ads Rp. 6.000.000 (include VAT & ads fee 20%)</span>

                  <span className='tw-text-white tw-mb-5'>Includes:</span>
                  <ol className='tw-text-white tw-gap-4 tw-mb-5 tw-flex-col tw-flex tw-list-disc tw-max-w-md tw-pl-6 tw-text-left'>
                    <li>{t('liveshop.li1')}</li>
                    <li>{t('liveshop.li2')}</li>
                    <li>{t('liveshop.li3')}</li>
                    <li>{t('liveshop.li4')}</li>
                  </ol>
                  <span className='tw-text-white tw-mb-5'>T&C:</span>
                  <ol className='tw-text-white tw-gap-4 tw-mb-5 tw-flex-col tw-flex tw-list-disc tw-max-w-md tw-pl-6 tw-text-left'>
                    <li>{t('liveshop.li_t1')}</li>
                    <li>{t('liveshop.li_t2')}</li>
                  </ol>
                  <span className='tw-mt-5 tw-text-white tw-block'><small>With minimum contract 6 month / 1 year.</small></span>
                  <span className='tw-text-white tw-block'><small><strong>Difference</strong> : <br />
                  - {t('liveshop.p_quality1')}, <br />
                  - {t('liveshop.p_quality2')}, <br />
                  - {t('liveshop.p_quality3')}</small></span>
                  {/* <span className='tw-mt-5 tw-text-white'>{t('liveshop.start_from')}</span>
                  <div className='tw-text-white tw-flex tw-flex-row md:tw-items-center tw-text-start'>
                    <h1 className='md:tw-text-3xl tw-text-md tw-font-semibold'>Rp 13.500.000,-</h1>
                    <span className='tw-ml-1'>({t('liveshop.after_tax')})</span>
                  </div> */}
                </div>
              <div className='tw-w-full tw-items-center tw-justify-center tw-z-10 tw-flex tw-flex-col'>
                <Image src={background_list.DSelfie } alt='' className='md:tw-block tw-hidden' />
                <StyledButton
                  title={t('liveshop.talk')}
                  className='tw-text-white tw-mt-5 tw-font-semibold md:tw-text-xl tw-text-xs tw-items-center tw-border-2 tw-border-white md:tw-px-6 tw-px-3 md:tw-py-2 tw-py-1 tw-rounded-full tw-justify-center md:tw-flex'
                  onClick={() => window.open(app_config.whatsappTemplate)}
                />
              </div>
            </div>

            {/* Start live Shopping */}
            <div className="bottom_packageNew tw-py-20">
                  <h2 className='md:tw-text-2xl tw-text-xl tw-font-semibold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-center'>Live Shopping Only (TikTok/Shopee)</h2>
                  <p className='tw-max-w-3xl tw-m-auto tw-text-center tw-mb-10'>
                    {t('liveshop.live_shopping_desc2')}
                  </p>

                  <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6 tw-mt-8">
                    <div className="tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-white tw-p-6 tw-rounded-3xl">
                      <h2 className="tw-text-2xl tw-font-bold">BASIC</h2>
                      <h3 className="tw-text-3xl tw-font-bold tw-mb-2">IDR 13.500.000</h3>
                      <p className="tw-text-sm tw-mb-4">*5% sharing revenue per month</p>

                      <ul className="tw-space-y-4 tw-text-sm">
                        <li className="tw-flex tw-items-start">
                          <span className="tw-mr-2 tw-mt-1">•</span>
                          <span>Including Ads (5.000.000 VAT & Ads fee 20%)</span>
                        </li>
                        <li className="tw-flex tw-items-start">
                          <span className="tw-mr-2 tw-mt-1">•</span>
                          <span>Durasi sesi live rata-rata 2 jam per hari, dengan total 26 hari per bulan.</span>
                        </li>
                        <li className="tw-flex tw-items-start">
                          <span className="tw-mr-2 tw-mt-1">•</span>
                          <span>Harga termasuk: Tax 11%, Smartphone, Wifi, Standard Property & equipment</span>
                        </li>
                        <li className="tw-flex tw-items-start">
                          <span className="tw-mr-2 tw-mt-1">•</span>
                          <span>Host dengan 3 bulan pengalaman & Relations Manager untuk membantu sesi live shopping brand Anda.</span>
                        </li>
                        <li className="tw-flex tw-items-start">
                          <span className="tw-mr-2 tw-mt-1">•</span>
                          <span>Optimizing Marketplace (Register campaign, optimize SEO, overview account health)</span>
                        </li>
                      </ul>

                      <p className="tw-text-sm tw-mt-6 tw-font-semibold">*With minimum contract 6 month / 1 year.</p>
                    </div>

                    <div className="tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-white tw-p-6 tw-rounded-3xl">
                      <h2 className="tw-text-2xl tw-font-bold">PREMIUM</h2>
                      <h3 className="tw-text-3xl tw-font-bold tw-mb-2">IDR 15.500.000</h3>
                      <p className="tw-text-sm tw-mb-4">*5% sharing revenue per month</p>

                      <ul className="tw-space-y-4 tw-text-sm">
                        <li className="tw-flex tw-items-start">
                          <span className="tw-mr-2 tw-mt-1">•</span>
                          <span>Including Ads (5.000.000 VAT & Ads fee 20%)</span>
                        </li>
                        <li className="tw-flex tw-items-start">
                          <span className="tw-mr-2 tw-mt-1">•</span>
                          <span>Durasi sesi live rata-rata 2 jam per hari, dengan total 26 hari per bulan.</span>
                        </li>
                        <li className="tw-flex tw-items-start">
                          <span className="tw-mr-2 tw-mt-1">•</span>
                          <span>Harga termasuk: Tax 11%, Smartphone, Wifi, Standard Property & equipment</span>
                        </li>
                        <li className="tw-flex tw-items-start">
                          <span className="tw-mr-2 tw-mt-1">•</span>
                          <span>Host dengan 9 bulan pengalaman & Relations Manager untuk membantu sesi live shopping brand Anda.</span>
                        </li>
                        <li className="tw-flex tw-items-start">
                          <span className="tw-mr-2 tw-mt-1">•</span>
                          <span>Optimizing Marketplace (Register campaign, optimize SEO, overview account health)</span>
                        </li>
                      </ul>

                      <p className="tw-text-sm tw-mt-6 tw-font-semibold">With minimum contract 6 month / 1 year.</p>
                    </div>

                    <div className="tw-space-y-4">
                      <div className="tw-border-2 tw-border-darkgreen tw-rounded-2xl tw-p-4 tw-bg-gradient-to-r tw-dark-green">
                        <p className="tw-text-white tw-font-semibold">*Optional</p>
                        <p className="tw-text-white">Add On 2 hours Live Duration +4.5 juta</p>
                      </div>

                      <div className="tw-border-2 tw-border-darkgreen tw-rounded-2xl tw-p-4 tw-bg-gradient-to-r tw-dark-green">
                        <p className="tw-text-white tw-font-semibold tw-mb-2">Enjoy a complimentary :</p>
                        <p className="tw-text-white tw-mb-4">
                          <span className="tw-font-bold tw-text-white">1 month free live shopping</span> upon completion of a <span className="tw-font-bold tw-text-white">1-year contract</span>
                        </p>
                        <p className="tw-text-white tw-font-bold tw-text-center tw-my-2">OR</p>
                        <p className="tw-text-white">
                          receive a <span className="tw-font-bold tw-text-white">cashback of 2 million</span> for finishing a <span className="tw-font-bold tw-text-white">6-month contract</span>.
                        </p>
                      </div>
                    </div>
                  </div>

              </div>
              {/* End live shopping */}       
            

            {/* What They Say */}
            <div className='tw-my-20'>
              <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-left tw-pb-1'>{t('liveshop.what_they')}</h1>
              <CardWhatTheySay data={swiperTestimony}/>
            </div>
            {/* Other Services */}
            <div className=' tw-mb-12'>
              <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-center tw-pb-1'>{t('liveshop.other_serv')}</h1>
              <div className='tw-relative'>
                <CenteredRadiantGradient />
                {!isMobile && (
                <div className='md:tw-block tw-hidden'>
                  <PackageSwiper data={swiperData2} cardClass="tw-min-h-[250px]" titleClass="tw-text-left tw-my-0 tw-px-20" devide={false} />
                </div>
                )}
                {isMobile && (
                <div className='tw-block md:tw-hidden'>
                  <CardPackage data={swiperData2} cardClass="tw-min-h-[250px] tw-p-10" devide={false}/>
                </div>
                )}
              </div>
            </div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default LiveShoppingExperience

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'live-shopping'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

  return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'privacy-policy'])),
		},
	}
}
